import React, { useContext } from "react";
import { Navigate } from "react-router";
import { SessionContext } from "../context/SessionContext";

export default function ProtectedRoute({ children, roles }) {
  const { session } = useContext(SessionContext);

  if (!session) {
    // Redirect unauthenticated users to sign-in
    const redirectTo = `/sign-in`;
    return <Navigate to={redirectTo} replace />;
  }

  if (roles && !roles.includes(session.role)) {
    // Redirect users with insufficient roles to an unauthorized page or home
    return <Navigate to="/" replace />;
  }

  // Render the children if authenticated and authorized
  return children;
}
